import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { getUser } from "@/lib/api";

import { HomePage, FeaturesPage, SolutionsPage, PricingPage, ContactPage, BookDemoPage } from "@/pages/Marketing";
import { LoginPage } from "@/pages/Login";
import { SuperAdmin } from "@/pages/SuperAdmin";
import { OrgAdmin } from "@/pages/OrgAdmin";
import { VisitorEvent, VisitorOrgLanding } from "@/pages/Visitor";
import { LeadFormPublic } from "@/pages/LeadFormPublic";
import { VmRegisterPublic, VmTicketRegisterPublic, VmPassPublic } from "@/pages/VmPublic";
import { VmCheckinPublic } from "@/pages/VmCheckinPublic";

function RequireAuth({ children, role }) {
  const user = getUser();
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    // route to the correct dashboard
    if (user.role === "super_admin") return <Navigate to="/admin" replace />;
    if (user.role === "org_admin") return <Navigate to="/dashboard" replace />;
    return <Navigate to="/login" replace />;
  }
  return children;
}

function RoleRedirect() {
  const user = getUser();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "super_admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        {/* Marketing */}
        <Route path="/" element={<HomePage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/book-demo" element={<BookDemoPage />} />

        {/* Auth */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/app" element={<RoleRedirect />} />

        {/* Dashboards */}
        <Route path="/admin/*" element={<RequireAuth role="super_admin"><SuperAdmin /></RequireAuth>} />
        <Route path="/dashboard/*" element={<RequireAuth role="org_admin"><OrgAdmin /></RequireAuth>} />

        {/* Public visitor experience */}
        <Route path="/e/:orgSlug" element={<VisitorOrgLanding />} />
        <Route path="/e/:orgSlug/:eventSlug" element={<VisitorEvent />} />

        {/* Public lead form */}
        <Route path="/lead/:formSlug" element={<LeadFormPublic />} />

        {/* Visitor Management public */}
        <Route path="/vm/register/:eventSlug" element={<VmRegisterPublic />} />
        <Route path="/vm/ticket/:token" element={<VmTicketRegisterPublic />} />
        <Route path="/vm/pass/:token" element={<VmPassPublic />} />
        <Route path="/vm/checkin/:eventToken" element={<VmCheckinPublic />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
